import React, { useState } from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import { useDropzone } from "react-dropzone";
import i18n from "../../../../utils/locale/i18n";
import reactDropzoneSkin from "../../../style/common/input-type/react-dropzone.skin";

const useStyles = createUseStyles(reactDropzoneSkin);

const UploadDropzoneMultiple = ({ onFilesChange }) => {
  const [acceptedFiles, setAcceptedFiles] = useState([]);

  const classes = useStyles();

  const setFiles = (files) => {
    setAcceptedFiles(files);
    onFilesChange(files);
  };

  const onDrop = (newAcceptedFiles) => {
    setFiles([...acceptedFiles, ...newAcceptedFiles]);
  };

  const removeFile = (indexFileToRemove) => {
    const updatedFiles = acceptedFiles.filter(
      (_, index) => index !== indexFileToRemove
    );
    setFiles(updatedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  return (
    <div>
      <div {...getRootProps({ className: classes.dropzone })}>
        <input {...getInputProps()} />
        <span>{i18n.t("drag_n_drop_file_multiple")}</span>
      </div>
      {acceptedFiles.length > 0 && (
        <ul>
          {acceptedFiles.map((file, index) => (
            <li key={index} className={classes["file-list-row"]}>
              {file.name} &nbsp;
              <button
                className="btn btn-default btn-outline-dark"
                type="button"
                onClick={() => removeFile(index)}
              >
                {i18n.t("remove_file")}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

UploadDropzoneMultiple.propTypes = {
  onFilesChange: PropTypes.func.isRequired,
};

export default UploadDropzoneMultiple;
